//
//
//
//

export default {
  props: [],
  data: function data() {
    return {
      has_router: false
    };
  },
  created: function created() {
    this.$data.has_router = !!this.$router;
  }
};